// extracted by mini-css-extract-plugin
module.exports = {"stats":"Stats_stats__SzLhZ","title":"Stats_title__3Iehe","value":"Stats_value__Um_gH","subtitle":"Stats_subtitle__1O8MP"};